module.exports = __webpack_public_path__ + "static/conference02-0d4341aab9e56b7be08ab75071c4679d.jpg";